/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';

import { IBaseListView } from '../../../icemedx-lib/src/components/baseview.component';
import {
  IcecontrolSettings,
  iceColumnDefinition,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelSettings,
  IcepanelsectionSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,
  IcecontrolPermission,
} from 'projects/icemedx-lib/src/components/models/icesettings';

import { IIceEntity } from 'projects/icemedx-lib/src/models/core/IceEntity';
import { appointmentindex } from 'projects/icemedx-lib/src/models/schedule/appointmentindex';
import { entity } from 'projects/icemedx-lib/src/models/common/entity';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';

import { AppService } from './app.service';
import { IceNavService } from '../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../icemedx-lib/src/login/login.service';
import { Iceutility } from 'projects/icemedx-lib/src/services/iceutility';
import { PatientService } from 'projects/icemedx-lib/src/services/patient/patient.service';
import { userTypes } from 'projects/icemedx-lib/src/login/login.config';

export class PhrBaseListView implements IBaseListView {
  dataAry: IIceEntity[] = null;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([])
  nameOfView: string = "";
  loading = true;
  dataViewSettings: IcepanelcontainerSettings = null;
  tables: IcemattableSettings[];
  private inLineEditing: boolean = false;

  constructor(private appSvc: AppService, private loginSvc: LoginService, private navSvc: IceNavService,
    private ptSvc: PatientService, private router: Router) {
  }

  getAppService(): AppService {
    return this.appSvc;
  }

  viewSetup(dat: IIceEntity[], feature: userTypes.USER_FEATURES = userTypes.USER_FEATURES.ufNone): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;

    try {
      if (dat == null) {
        return null;
      }

      this.dataAry = dat;

      //////////////////////
      // Appointment
      this.tables = [
        new IcemattableSettings(
          this.nameOfView + "Table",
          this.onGetColumnDefinition(),
          this.dataSource,
          [],
          this.isRowSelectionEnabled(),
          null,
          this.inLineEditing,
          null,
          this.loading
        )
      ];
      let apptGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, this.tables, this.getPermission(feature))
      ];

      this.dataSource.data = this.onGetData(this.dataAry);

      let apptSections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings(this.nameOfView + "ViewSection", { class: ["yalla"], styles: { width: "100%" } }, apptGroups, [], null, this.getPermission(feature))
      ];

      let panels: IcepanelSettings[] = [
        new IcepanelSettings(this.nameOfView + "View", "", this.nameOfView, "", apptSections, null, this.getPermission(feature)),
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      setup = new IcepanelcontainerSettings(this.nameOfView + "ViewContainer", panelrows);
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  getPermission(feature): IcecontrolPermission {
    if (!Iceutility.isdefined(feature)) {
      feature = userTypes.USER_FEATURES.ufNone;
    }

    let userInfo = this.loginSvc.GetSessionUserInfo();

    let feaAccess = this.loginSvc.getFeatureAccess(userInfo, this.appSvc.getCurrentAccount(), feature);
    return new IcecontrolPermission(feature, feaAccess);
  }

  isRowSelectionEnabled(): boolean {
    return false;
  }

  onGetColumnDefinition(): iceColumnDefinition[] {
    return [];
  }

  onGetData(originalData: IIceEntity[]): any[] {
    return originalData;
  }

  refreshTableData(rows): void {
    if (this.tables && this.tables.length > 0) {
      this.tables[0].loadingIndicator = false;
      this.tables[0].iRows.data = this.onGetData(rows); 
    }
  }

  setInlineEditing(val: boolean): void {
    this.inLineEditing = val;
  }

  getInlineEditing(): boolean {
    return this.inLineEditing;
  }

  //////////////////////////////////
  // Toolbar Events
  onToolbarMenuItemOpen(event) {
    this.appSvc.onDefaultToolbarMenuItemOpen(event);
  }
  onToolbarMenuItemClick(event) {
    this.appSvc.onDefaultToolbarMenuItemClick(event, this.router);
  }
}
